<span class="d-block">{{ step1.getspan1 | translate }}</span>

 <app-form-input 
    [parentForm]="parentForm" 
    [value]="avisInitial.idWeb" 
    [label]="step1.getidweb"
    [type]="'text'" [rule]="'pattern_9|required'" [errorMessage]="{'pattern' : 'ctr_pattern9'}"
    [name]="getUid()+'_SepAtt_idWeb'">
 </app-form-input>
 
 <app-form-input 
   [parentForm]="parentForm" 
   [value]="avisInitial.datePublication" 
   
   [label]="step1.getdatepublication"
   [type]="'date'" [rule]="''"
   [name]="getUid()+'_SepAtt_datePublication'">
</app-form-input>



